import React from 'react';
import { Page, Text, View, Document, Font, StyleSheet } from '@react-pdf/renderer';
import Image from '../../common/PDF/Image';
import styles from '../../common/PDF/LayoutStylesheet';
import Table from '../../common/PDF/Table';

import { splitByThousands, convertToThousands, addPercent } from '../../../helpers/NumberFormatter';

const renderTable=(data)=>{
	const columns=[
	   {key: 'title', title: 'Track', width: 25},
	   {key: 'isrc', title: 'ISRC', width: 25},
	   {key: 'curr_radio_units', title: 'Radio Streams', width: 25, formatFn: splitByThousands},
	   {key: 'curr_collection_units', title: 'Collection Streams', width: 25, formatFn: splitByThousands},

   ];
	   
	return <Table
		columns={columns}
		items={data}
	/>
}

const innerStyles = StyleSheet.create({
	overviewContainer: {
		flexDirection: 'row',
		// flexWrap: 'wrap',
		justifyContent: 'space-between',
		// marginTop: 24,
		borderWidth: 1,
		borderColor: '#E8E8EA',
		fontSize: 8,
		flexGrow: 1,
	},

	overviewBox: {
		flexDirection: 'column',
		padding: 10
	},
	title: {
		fontSize: 8,
		marginBottom: 20
	}
});


export default (props) => {
	const { data: { tables, images, reportTitle }, widgetProps: { widgetState }  } = props;
		
	return <Document>
		<Page size="A4" style={styles.page}>
			<View style={styles.reportTitle}>
				<Text className={styles.smallHeaderNotUnderline}>{reportTitle}</Text>
			</View>
			<View style={styles.section}>
				<View style={innerStyles.overviewContainer}>
					{tables.spotify_discovery_previous.map(item=><View style={innerStyles.overviewBox}>
							<Text style={innerStyles.title}>{item.title}</Text>
							<Text>{convertToThousands(item.value)}</Text>
						</View>
					)}
				</View>
			</View>
			<View style={styles.columnSection}>
				<Text style={styles.smallHeader}>Spotify Radio and Collection Streams</Text>
				<Image source={images.spotify_discovery_radio_collection} />
			</View>
			<View style={styles.columnSection}>
				<Text style={styles.smallHeader}>Top Discovery Mode Tracks</Text>	
				{widgetState.top_tracks.mode != 'table' && 
				  <Image source={images.spotify_discovery_top_tracks} style={styles.image} />
			  	}
				
				{widgetState.top_tracks.mode == 'table' &&
				  renderTable(tables.spotify_discovery_top_tracks)
				}
			</View>  
		</Page>
		<Page size="A4" style={styles.page}>
			<View style={styles.columnSection}>
				<Text style={styles.smallHeader}>Spotify Radio Streams</Text>
				<Image source={images.spotify_discovery_metrics_radio} />
			</View>
			<View style={styles.section}>
			  <View style={styles.half}>
				<Text style={styles.smallHeader}>Spotify Collection Streams</Text>
				<Image source={images.spotify_discovery_metrics_collection} />
			  </View>
			  <View style={styles.half}>
				<Text style={styles.smallHeader}>Spotify Artists Streams</Text>
				<Image source={images.spotify_discovery_metrics_artist} />
			  </View>
			</View>  
			<View style={styles.section}>
			  <View style={styles.half}>
				<Text style={styles.smallHeader}>Spotify Search Streams</Text>
				<Image source={images.spotify_discovery_metrics_search} />
			  </View>
			  <View style={styles.half}>
				<Text style={styles.smallHeader}>Spotify Discovery Streams</Text>
				<Image source={images.spotify_discovery_metrics_discovery} />
			  </View>
			</View>  
		</Page>
	</Document>
};